import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const API_URL = `${config.backendUrl}/employees`;

export const fetchEmployees = createAsyncThunk(
  "employees/fetchEmployees",
  async (_, { getState, rejectWithValue }) => {
    const { employees } = getState();
     if (employees.lastFetch && Date.now() - employees.lastFetch < 5000) {
      return employees.employees;
    }
    try {
      const response = await axiosInstance.get(API_URL);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addEmployee = createAsyncThunk(
  "employees/addEmployee",
  async (employeeData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, employeeData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "employees/updateEmployee",
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/${id}`, updatedData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "employees/deleteEmployee",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  employees: [],
  loggedUser: null,
  status: "idle", // "loading" | "succeeded" | "failed"
  error: null,
  lastFetch: null, // Timestamp of last successful fetch
};

const employeeSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    forceRefreshEmployees(state) {
      state.lastFetch = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.employees = action.payload;
        state.lastFetch = Date.now(); // Update last fetch timestamp

        const Fname = localStorage.getItem('name');
        const Lname = localStorage.getItem('lastName');
        const FullName = `${Fname} ${Lname}`;

        const matchedUser = action.payload.find(
          (emp) => `${emp.EmpFirstName} ${emp.EmpLastName}` === FullName
        );

        state.loggedUser = matchedUser || null;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(addEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload);
        state.lastFetch = null;
      })

      .addCase(updateEmployee.fulfilled, (state, action) => {
        const index = state.employees.findIndex(emp => emp.id === action.payload.id);
        if (index !== -1) {
          state.employees[index] = action.payload;
        }

        if (state.loggedUser && state.loggedUser.id === action.payload.id) {
          state.loggedUser = action.payload;
        }
        state.lastFetch = null;
      })

      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.employees = state.employees.filter(emp => emp.id !== action.payload);
      });
  },
});

export const { forceRefreshEmployees } = employeeSlice.actions;
export default employeeSlice.reducer;